/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ movement: NonNullable<unknown>, muscle: NonNullable<unknown> }} Prescription_Reason_Movement_SlotInputs */

const en_us2_prescription_reason_movement_slot = /** @type {(inputs: Prescription_Reason_Movement_SlotInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your ${i?.movement} movement for ${i?.muscle}`)
};

const pt_br2_prescription_reason_movement_slot = /** @type {(inputs: Prescription_Reason_Movement_SlotInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seu movimento de ${i?.movement} para ${i?.muscle}`)
};

const es_419_prescription_reason_movement_slot = /** @type {(inputs: Prescription_Reason_Movement_SlotInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tu movimiento de ${i?.movement} para ${i?.muscle}`)
};

const pt_pt2_prescription_reason_movement_slot = /** @type {(inputs: Prescription_Reason_Movement_SlotInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O teu movimento de ${i?.movement} para ${i?.muscle}`)
};

const fr_fr2_prescription_reason_movement_slot = /** @type {(inputs: Prescription_Reason_Movement_SlotInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ton mouvement de ${i?.movement} pour ${i?.muscle}`)
};

const de_de2_prescription_reason_movement_slot = /** @type {(inputs: Prescription_Reason_Movement_SlotInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Deine Bewegung „${i?.movement}“ für ${i?.muscle}`)
};

const it_it2_prescription_reason_movement_slot = /** @type {(inputs: Prescription_Reason_Movement_SlotInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Il tuo movimento di ${i?.movement} per ${i?.muscle}`)
};

/**
* | output |
* | --- |
* | "Your {movement} movement for {muscle}" |
*
* @param {Prescription_Reason_Movement_SlotInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const prescription_reason_movement_slot = /** @type {((inputs: Prescription_Reason_Movement_SlotInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prescription_Reason_Movement_SlotInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_prescription_reason_movement_slot(inputs)
	if (locale === "es-419") return es_419_prescription_reason_movement_slot(inputs)
	if (locale === "pt-PT") return pt_pt2_prescription_reason_movement_slot(inputs)
	if (locale === "fr-FR") return fr_fr2_prescription_reason_movement_slot(inputs)
	if (locale === "de-DE") return de_de2_prescription_reason_movement_slot(inputs)
	if (locale === "it-IT") return it_it2_prescription_reason_movement_slot(inputs)
	return en_us2_prescription_reason_movement_slot(inputs)
});
export { prescription_reason_movement_slot as "prescription.reason.movement_slot" }